var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useCountdown } from "../../../hooks/useCountdown";
import { useEffect } from "react";
import { Link } from "./styes";
var pluralize = function (word, qty) { return (qty == 1 ? word : "".concat(word, "s")); };
var ResendLink = function (_a) {
    var onClick = _a.onClick, href = _a.href;
    var _b = useCountdown(1), seconds = _b.seconds, startCountdown = _b.startCountdown, resetCountdown = _b.resetCountdown, hasFinished = _b.hasFinished, isActive = _b.isActive;
    if (hasFinished)
        resetCountdown();
    useEffect(function () {
        startCountdown();
    }, []);
    return (_jsx(Box, __assign({ marginBottom: "3rem" }, { children: _jsxs(Link, __assign({ renderAs: "a", onClick: function (evt) {
                if (isActive)
                    return evt.preventDefault();
                onClick(evt);
                startCountdown();
            }, href: href, color: isActive ? "smoke" : "primary", disableDecoration: isActive }, { children: [!isActive && "Reenviar e-mail", isActive &&
                    "Solicitar reenvio em ".concat(seconds, " ").concat(pluralize("segundo", seconds), "...")] })) })));
};
export default ResendLink;
